export default __webpack_public_path__ + "static/media/status-suppression.52de4c2b.svg";